/** Entry provenance. Kept free of zod so the web bundle doesn't pull in the validation library. */
export const ENTRY_SOURCES = [
  'search',
  'recent',
  'favorite',
  'custom',
  'ai_text',
  'ai_photo',
  'ai_label',
  'barcode',
  'usual',
  'copy',
  'what_fits',
  'quick',
  'import',
] as const;

export type EntrySource = (typeof ENTRY_SOURCES)[number];

export const AI_SOURCES: ReadonlySet<EntrySource> = new Set(['ai_text', 'ai_photo', 'ai_label', 'what_fits']);
